import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class LocaleService {
  currentLocale = "es";
  get locale() {
    return this.currentLocale;
  }

  constructor(private translateService: TranslateService) {
    this.currentLocale = navigator.language.substr(0, 2);
    if (this.currentLocale !== "es") {
      this.currentLocale = "en";
    }
  }

  async translate(text: string): Promise<string> {
    return this.translateService.get(text).toPromise();
    // .map((translation: string) => {
    //   return translation;
    // })
    // .catch(() => {
    //   return '';
    // })
    // .toPromise();
  }
}
